/**
 * Badge — renders a status label with color.
 *
 * Props:
 *   status  {string}  — raw API value (e.g. 'scheduled')
 *   labels  {Object}  — { [status]: frenchLabel }
 *   colors  {Object}  — { [status]: { bg, text } }
 *   className {string} — optional extra classes
 */
const Badge = ({ status, labels, colors, className = '' }) => {
  const label = labels?.[status] ?? status;
  const color = colors?.[status] ?? { bg: 'bg-gray-100', text: 'text-gray-700' };

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${color.bg} ${color.text} ${className}`}
    >
      {label}
    </span>
  );
};

export default Badge;
